import React from 'react';

export const BabyIcon = (props) => {
  return (
    <svg width='40px' height='40px' viewBox='0 0 40 40' {...props}>
      <g id='icon/kudos/zwitsal' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
        <g
          id='Group'
          transform='translate(4.000000, 13.000000)'
          stroke='currentColor'
          strokeWidth='4'
        >
          <path
            d='M17.4032258,-2 C20.639728,-2 23.6100361,-0.860794967 25.9356926,1.03784899 C27.9502494,2.68251409 29.4800025,4.89783829 30.2806018,7.436296 C31.1061391,7.68695702 31.8348572,8.12578905 32.4227755,8.69471368 C33.4044653,9.64468855 34,10.9626123 34,12.42 C34,13.8614632 33.4157316,15.1664632 32.4710974,16.1110974 C31.7035821,16.8786127 30.6981691,17.4082302 29.5757594,17.5798536 L29.449,17.595 L29.3549885,17.7822882 C28.3884042,19.6177608 27.0115184,21.2035905 25.3459005,22.4172149 L25.0302432,22.6403778 C22.8601177,24.1285393 20.2335114,25 17.4032258,25 L14.5967742,25 C11.7664886,25 9.13988227,24.1285393 6.9697568,22.6403778 C5.16219505,21.400844 3.67200732,19.7324778 2.64501148,17.7822882 L2.55,17.595 L2.42504547,17.5798539 C1.38823203,17.4214321 0.451793867,16.957974 -0.289810112,16.2839386 L-0.471097398,16.1110974 C-1.4157316,15.1664632 -2,13.8614632 -2,12.42 C-2,10.9785368 -1.4157316,9.6735368 -0.471097398,8.7289026 C0.110650593,8.14715461 0.829072621,7.70208066 1.6318355,7.44562644 C2.47379004,4.89421751 4.03402175,2.66903778 6.07161239,1.02130938 C8.4081541,-0.868170308 11.3704057,-2 14.5967742,-2 L17.4032258,-2 Z'
            id='Combined-Shape'
          ></path>
        </g>
        <circle id='Oval-Copy' fill='currentColor' cx='25' cy='22' r='3'></circle>
        <circle id='Oval' fill='currentColor' cx='15' cy='22' r='3'></circle>
        <path
          d='M16.4401904,2.1443929 C15.700848,2.96058888 15.3311768,4.16195675 15.3311768,5.74849652 C15.3311768,7.33503628 16.2841813,8.44378467 18.1901904,9.07474167 C20.7030163,9.35779826 22.0702223,8.77811667 22.2918085,7.33569692 C22.5133946,5.89327716 21.7995753,5.07718997 20.1503506,4.88743535'
          id='Path-2'
          stroke='currentColor'
          strokeWidth='3'
          strokeLinecap='round'
          transform='translate(18.831177, 5.644393) rotate(180.000000) translate(-18.831177, -5.644393) '
        ></path>
        <path
          d='M15,30 C18.3277995,28.4397786 21.7709961,28.4397786 25.3295898,30'
          id='Path-3'
          stroke='currentColor'
          strokeWidth='4'
          strokeLinecap='round'
        ></path>
      </g>
    </svg>
  );
};
